import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnDestroy } from '@angular/core';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { ModalFooterComponent } from '@base/components/private/modals/modal-footer/modal-footer.component';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { ModalService } from '@base/services/private/modal.service';
import { GlobalService } from '@base/services/private/global.service';

@Component({
  selector: 'app-modal-warning-for-preview-account',
  imports: [ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent, forwardRef(() => TranslatePipe)],
  templateUrl: './modal-warning-for-preview-account.component.html',
  styleUrl: './modal-warning-for-preview-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalWarningForPreviewAccountComponent implements OnDestroy {
  private readonly modalSrv = inject(ModalService);
  private readonly globalSrv = inject(GlobalService);

  @Input() modalId = '';

  ngOnDestroy(): void {
    this.globalSrv.destroyModalRef(this.modalId);
  }

  /**
   * Closes the modal using the provided modalId.
   * @returns void
   */
  close(): void {
    this.modalSrv.close(this.modalId);
  }
}
